const hexToRgb = (hex, opacity) => {
    opacity = opacity ? opacity : 0.0;

    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');

    // Parse the hex values
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return `rgb(${r}, ${g}, ${b}, ${opacity})`;
};

export default hexToRgb;